module.exports = __webpack_public_path__ + "img/twbgscq_bg.f503314c.png";